import React from "react"
import { IconMenu, IconButton, FontIcon, MenuItem } from "material-ui"
import strings from "../../../localization/strings"
import AdhocReportDialog from "./AdhocReportDialog"
import PunchDetailReportDialog from "./PunchDetailReportDialog"
import TimecardSummaryReportDialog from "./TimecardSummaryReportDialog"
import TimecardAuditReportDialog from "./TimecardAuditReportDialog"
import InOutReport from "./InOutReport"
import EstimatedTimeReportDialog from "./EstimatedTimeReportDialog"
import PunchQuestionResponseReportDialog from "./PunchQuestionResponseReportDialog"
import ManualEntriesReportDialog from "./ManualEntriesReportDialog"

import BiometricLocationExceptionsReportDialog from "./BiometricLocationExceptionsReportDialog"

import { ECustomReportLocation, EExceptionType, ICustomReportDocument, IDate, INewCustomReportParameters, IPayrollPayCalendar, ITimecardAdhocExportRequest, IUserFilter } from "../../../models"
import * as api from "../../../api"
import AppStateStore from "../../../stores/AppStateStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import * as payrollHelper from "../../../helpers/payrollHelper"
import AccountStore from "../../../stores/AccountStore"
import { hasPermission } from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"

interface IProps {
    referenceDate: IDate
    selectedPayrollPayCalendar: IPayrollPayCalendar
    userFilter: IUserFilter

    // job->Timecard report
    jobId?: string

    // Timecard page report
    filterByDefaultHierarchy?: boolean
    filterDirectReportsOnly?: boolean
    filterByPunchHierarchy?: boolean
    filterByException?: boolean
    filterExceptions?: EExceptionType[]
}

interface IState {
    openAdhocReportDialog: boolean
    openPunchDetailReportDialog: boolean
    openTimecardSummaryReportDialog: boolean
    openTimecardAuditReportDialog: boolean
    openEstimatedTimeReportDialog: boolean
    openInOutReportDailog: boolean
    openPunchQuestionResponseReportDialog: boolean
    openManualEntriesReportDialog: boolean
    openBiometricLocationExceptionsReportDialog: boolean

    newReports: ICustomReportDocument[]
    adhocTimecardReports: ITimecardAdhocExportRequest[]
    editAdhocReport: ITimecardAdhocExportRequest | null
}

export default class TimecardReport extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAdhocReportDialog: false,
            openPunchDetailReportDialog: false,
            openTimecardSummaryReportDialog: false,
            openTimecardAuditReportDialog: false,
            openEstimatedTimeReportDialog: false,
            openInOutReportDailog: false,
            openPunchQuestionResponseReportDialog: false,
            openManualEntriesReportDialog: false,
            openBiometricLocationExceptionsReportDialog: false,
            newReports: [],
            adhocTimecardReports: [],
            editAdhocReport: null
        }
    }

    componentDidMount() {
        this.getNewReportTypes()
        this.getTimecardAdhocReports()
    }

    getNewReportTypes() {
        api.getCustomReportTypes(ECustomReportLocation.TimecardTab).then(res =>
            this.setState({ newReports: res.data })
        )
    }

    getTimecardAdhocReports() {
        api.fetchAdhocReports(AccountStore.getCurrentAccount().Id).then(res =>
            this.setState({ adhocTimecardReports: res.data.TimecardAdhocReports })
        )
    }

    render() {
        return (
            <div>
                {hasPermission(AuthenticationStore.Permissions.Account.ViewTimeReports) &&
                    <IconMenu
                        iconButtonElement={
                            <IconButton data-intercom-target={"Timecards-Select-Report"} tooltip={strings.Reports}>
                                <FontIcon className="fa fa-file-text" style={{ fontSize: 20 }} />
                            </IconButton>
                        }
                    >
                        <div>
                            <MenuItem
                                data-intercom-target={"Timecards-Reports-Btn-AdhocReportDialog"}
                                primaryText={strings.Adhoc_Report}
                                leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                                onTouchTap={() => this.setState({ openAdhocReportDialog: true })}
                            />
                            <MenuItem
                                data-intercom-target={"Timecards-Reports-Btn-OpenPunchDetailReportDialog"}
                                primaryText={strings.Punch_Detail_Report}
                                leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                                onTouchTap={() => this.setState({ openPunchDetailReportDialog: true })}
                            />
                            <MenuItem
                                data-intercom-target={"Timecards-Reports-Btn-OpenTimecardSummaryReportDialog"}
                                primaryText={strings.TimecardSummaryReport}
                                leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                                onTouchTap={() => this.setState({ openTimecardSummaryReportDialog: true })}
                            />
                            <MenuItem
                                data-intercom-target={"Timecards-Reports-Btn-OpenTimecardAuditReportDialog"}
                                primaryText={strings.TimecardAuditReport}
                                leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                                onTouchTap={() => this.setState({ openTimecardAuditReportDialog: true })}
                            />
                            {!this.props.jobId &&
                                <MenuItem
                                    data-intercom-target={"Timecards-Reports-Btn-OpenEstimatedTimeReportDialog"}
                                    primaryText={strings.Estimated_Time_Report}
                                    leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                                    onTouchTap={() => this.setState({ openEstimatedTimeReportDialog: true })}
                                />
                            }
                            {!this.props.jobId &&
                                <MenuItem
                                    data-intercom-target={"Timecards-Reports-Btn-OpenInOutReportDialog"}
                                    primaryText={strings.In_Out_Report}
                                    leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                                    onTouchTap={() => this.setState({ openInOutReportDailog: true })}
                                />
                            }
                            {AccountStore.getPunchQuestionEnabled() &&
                                <MenuItem
                                    data-intercom-target={"Timecards-Reports-Btn-OpenPunchQuestionResponseReportDialog"}
                                    primaryText={strings.Punch_Question_Response_Report}
                                    leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                                    onTouchTap={() => this.setState({ openPunchQuestionResponseReportDialog: true })}
                                />
                            }
                            <MenuItem
                                data-intercom-target={"Timecards-Reports-Btn-OpenManualEntriesReportDialog"}
                                primaryText={strings.Manual_Entries_Report}
                                leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                                onTouchTap={() => this.setState({ openManualEntriesReportDialog: true })}
                            />
                            <MenuItem
                                data-intercom-target={"Timecards-Reports-Btn-OpenBiometricLocationExceptionsReportDialog"}
                                primaryText={"Biometric & Location Exceptions"}
                                leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                                onTouchTap={() => this.setState({ openBiometricLocationExceptionsReportDialog: true })}
                            />
                        </div>

                        {this.state.newReports.map(i =>
                            <MenuItem
                                key={i.Id}
                                data-intercom-target={"Timecards-Reports-Btn-OpenNewReport"}
                                primaryText={i.Name}
                                leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                                onTouchTap={() => AppStateStore.setNewCustomReportDialogContent({
                                    newCustomReportDoc: i,
                                    newCustomReportParameters: {
                                        LevelIdFilter: HierarchySettingsStore.getGlobalLevelItemFilterId()
                                            ? HierarchySettingsStore.getGlobalLevelItemFilterId()
                                            : null,
                                        Date1: this.props.referenceDate,
                                        PayGroupIds: payrollHelper.getPayGroupIdsByPayrollPayCalendar(this.props.selectedPayrollPayCalendar),
                                        UserFilter: this.props.userFilter,
                                        FilterByDefaultHierarchy: this.props.filterByDefaultHierarchy,
                                        FilterByPunchHierarchy: this.props.filterByPunchHierarchy,
                                        FilterDirectReportsOnly: this.props.filterDirectReportsOnly,
                                        FilterByException: this.props.filterByException,
                                        FilterExceptions: this.props.filterExceptions,
                                        JobId: this.props.jobId
                                    } as INewCustomReportParameters
                                })}
                            />
                        )}
                        {this.state.adhocTimecardReports.map((report) =>
                            <MenuItem
                                key={report.ReportId}
                                primaryText={report.ReportName}
                                leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                                data-intercom-target={`AdhocTimecard-Reports-Btn-${report.ReportName}`}
                                onTouchTap={() => {
                                    this.setState({
                                        editAdhocReport: report,
                                        openAdhocReportDialog: true
                                    })
                                }}
                            />
                        )}
                    </IconMenu>
                }

                {this.state.openAdhocReportDialog &&
                    <AdhocReportDialog
                        referenceDate={this.props.referenceDate}
                        selectedPayrollPayCalendar={this.props.selectedPayrollPayCalendar}
                        userFilter={this.props.userFilter}
                        handleClose={() => this.setState({ openAdhocReportDialog: false, editAdhocReport: null })}

                        jobId={this.props.jobId}
                        filterByDefaultHierarchy={this.props.filterByDefaultHierarchy}
                        filterDirectReportsOnly={this.props.filterDirectReportsOnly}
                        filterByPunchHierarchy={this.props.filterByPunchHierarchy}
                        filterByException={this.props.filterByException}
                        filterExceptions={this.props.filterExceptions}

                        editAdhocReport={this.state.editAdhocReport}
                        updateTimecardAdhocReport={(adhocTimecardReports) => this.setState({ adhocTimecardReports })}
                        adhocTimecardReports={this.state.adhocTimecardReports}
                    />
                }

                {this.state.openPunchDetailReportDialog &&
                    <PunchDetailReportDialog
                        referenceDate={this.props.referenceDate}
                        selectedPayrollPayCalendar={this.props.selectedPayrollPayCalendar}
                        userFilter={this.props.userFilter}
                        handleClose={() => this.setState({ openPunchDetailReportDialog: false })}

                        jobId={this.props.jobId}
                        filterByDefaultHierarchy={this.props.filterByDefaultHierarchy}
                        filterDirectReportsOnly={this.props.filterDirectReportsOnly}
                        filterByPunchHierarchy={this.props.filterByPunchHierarchy}
                        filterByException={this.props.filterByException}
                        filterExceptions={this.props.filterExceptions}
                    />
                }

                {this.state.openTimecardSummaryReportDialog &&
                    <TimecardSummaryReportDialog
                        selectedPayrollPayCalendar={this.props.selectedPayrollPayCalendar}
                        userFilter={this.props.userFilter}
                        handleClose={() => this.setState({ openTimecardSummaryReportDialog: false })}

                        jobId={this.props.jobId}
                        filterByDefaultHierarchy={this.props.filterByDefaultHierarchy}
                        filterDirectReportsOnly={this.props.filterDirectReportsOnly}
                        filterByPunchHierarchy={this.props.filterByPunchHierarchy}
                        filterByException={this.props.filterByException}
                        filterExceptions={this.props.filterExceptions}
                    />
                }

                {this.state.openTimecardAuditReportDialog &&
                    <TimecardAuditReportDialog
                        selectedPayrollPayCalendar={this.props.selectedPayrollPayCalendar}
                        userFilter={this.props.userFilter}
                        handleClose={() => this.setState({ openTimecardAuditReportDialog: false })}

                        jobId={this.props.jobId}
                        filterByDefaultHierarchy={this.props.filterByDefaultHierarchy}
                        filterDirectReportsOnly={this.props.filterDirectReportsOnly}
                        filterByPunchHierarchy={this.props.filterByPunchHierarchy}
                        filterByException={this.props.filterByException}
                        filterExceptions={this.props.filterExceptions}
                    />
                }

                {this.state.openInOutReportDailog &&
                    <InOutReport
                        selectedPayrollPayCalendar={this.props.selectedPayrollPayCalendar}
                        userFilter={this.props.userFilter}
                        handleClose={() => this.setState({ openInOutReportDailog: false })}

                        filterByDefaultHierarchy={this.props.filterByDefaultHierarchy}
                        filterDirectReportsOnly={this.props.filterDirectReportsOnly}
                        filterByPunchHierarchy={this.props.filterByPunchHierarchy}
                        filterByException={this.props.filterByException}
                        filterExceptions={this.props.filterExceptions}
                    />
                }

                {this.state.openEstimatedTimeReportDialog &&
                    <EstimatedTimeReportDialog
                        referenceDate={this.props.referenceDate}
                        selectedPayrollPayCalendar={this.props.selectedPayrollPayCalendar}
                        userFilter={this.props.userFilter}
                        handleClose={() => this.setState({ openEstimatedTimeReportDialog: false })}

                        filterByDefaultHierarchy={this.props.filterByDefaultHierarchy}
                        filterDirectReportsOnly={this.props.filterDirectReportsOnly}
                        filterByPunchHierarchy={this.props.filterByPunchHierarchy}
                        filterByException={this.props.filterByException}
                        filterExceptions={this.props.filterExceptions}
                    />
                }

                {this.state.openPunchQuestionResponseReportDialog &&
                    <PunchQuestionResponseReportDialog
                        referenceDate={this.props.referenceDate}
                        selectedPayrollPayCalendar={this.props.selectedPayrollPayCalendar}
                        userFilter={this.props.userFilter}
                        handleClose={() => this.setState({ openPunchQuestionResponseReportDialog: false })}

                        jobId={this.props.jobId}
                        filterByDefaultHierarchy={this.props.filterByDefaultHierarchy}
                        filterDirectReportsOnly={this.props.filterDirectReportsOnly}
                        filterByPunchHierarchy={this.props.filterByPunchHierarchy}
                        filterByException={this.props.filterByException}
                        filterExceptions={this.props.filterExceptions}
                    />
                }

                {this.state.openManualEntriesReportDialog &&
                    <ManualEntriesReportDialog
                        referenceDate={this.props.referenceDate}
                        selectedPayrollPayCalendar={this.props.selectedPayrollPayCalendar}
                        userFilter={this.props.userFilter}
                        handleClose={() => this.setState({ openManualEntriesReportDialog: false })}

                        jobId={this.props.jobId}
                        filterByDefaultHierarchy={this.props.filterByDefaultHierarchy}
                        filterDirectReportsOnly={this.props.filterDirectReportsOnly}
                        filterByPunchHierarchy={this.props.filterByPunchHierarchy}
                        filterByException={this.props.filterByException}
                        filterExceptions={this.props.filterExceptions}
                    />
                }

                {this.state.openBiometricLocationExceptionsReportDialog &&
                    <BiometricLocationExceptionsReportDialog
                        referenceDate={this.props.referenceDate}
                        selectedPayrollPayCalendar={this.props.selectedPayrollPayCalendar}
                        userFilter={this.props.userFilter}
                        handleClose={() => this.setState({ openBiometricLocationExceptionsReportDialog: false })}

                        jobId={this.props.jobId}
                        filterByDefaultHierarchy={this.props.filterByDefaultHierarchy}
                        filterDirectReportsOnly={this.props.filterDirectReportsOnly}
                        filterByPunchHierarchy={this.props.filterByPunchHierarchy}
                        filterByException={this.props.filterByException}
                        filterExceptions={this.props.filterExceptions}
                    />
                }
            </div>
        )
    }
}
